import { getAvailabilityStatus } from "../../../utils/nodeAvailability";

const includes = (value, term) => String(value == null ? "" : value).toLocaleLowerCase().includes(term);
const serviceFields = { hospital: "hospitalSleepAvailable", home: "homeSleepAvailable", opd: "opdDoctorVisitAvailable" };

export const parseNodeSharedRoomCount = (value, node = {}) => {
  if (value == null || String(value).trim() === "") return getNodeSharedRoomCount({ ...node, sharedRoomCount: null });
  const count = Number(value);
  if (!Number.isSafeInteger(count) || count < 1) throw new Error("Shared Rooms must be a whole number greater than zero, or left blank.");
  return count;
};

// CHG keeps its original default whenever the optional count is blank.
export const getNodeSharedRoomCount = (node) => {
  if (node.sharedRoomCount != null) {
    return Number.isSafeInteger(node.sharedRoomCount) && node.sharedRoomCount > 0 ? node.sharedRoomCount : null;
  }
  const code = String(node.nodecode || "").trim().toUpperCase();
  const name = String(node.nodename || "").trim().toLowerCase();
  return code === "CHG" || ["chg", "chularat hospital group"].includes(name) ? 9 : null;
};

export const filterNodeDirectory = (nodes, { search = "", availability = "", service = "" } = {}) => {
  const term = search.trim().toLocaleLowerCase();
  return nodes.reduce((result, node) => {
    const nodeStatus = getAvailabilityStatus(node);
    if (availability && nodeStatus !== availability) return result;
    const nodeMatches = !term || [node.nodename, node.nodecode, node.nodeIndex].some(value => includes(value, term));
    const visibleCustomers = (node.customers || []).filter(customer =>
      (nodeMatches || [customer.CustomerNameTH, customer.CustomerNameEN].some(value => includes(value, term))) &&
      (!service || customer[serviceFields[service]] === true),
    );
    if ((!nodeMatches || service) && !visibleCustomers.length) return result;
    result.push({ ...node, visibleCustomers });
    return result;
  }, []).sort((a, b) => String(a.nodeIndex == null ? "" : a.nodeIndex).trim().localeCompare(String(b.nodeIndex == null ? "" : b.nodeIndex).trim(), undefined, { numeric: true, sensitivity: "base" }));
};
